import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PackageList from '@components/LocalMerchant/ZhiTuiBao/PackageList'
import { Button } from 'hljd'
import { buyZhiTuiBao } from '@components/LocalMerchant/ZhiTuiBao/util'
import { PATH_ZTB_ORDER } from '@components/LocalMerchant/ZhiTuiBao/constant'
import { hashHistory } from 'react-router'

@observer
export default class extends Component {
  render() {
    const { can_buy_packet } = this.props
    return (
      <div>
        <div style={{ marginBottom: 20 }} className="clearfix">
          <div style={{ float: 'right' }}>
            {can_buy_packet == '1' && (
              <>
                <Button
                  onClick={() => {
                    hashHistory.push(PATH_ZTB_ORDER)
                  }}
                  style={{ marginRight: 20 }}
                >
                  激活顺序设置
                </Button>
                <Button type="primary" onClick={() => buyZhiTuiBao()}>
                  购买套包
                </Button>
              </>
            )}
          </div>
        </div>

        <PackageList />
      </div>
    )
  }
}
